import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { useScrolled, useScrollSpy, scrollToSection } from '../../hooks/useScrollSpy';
import { exportToHTML } from '../../utils/exportHTML';
import { theme } from '../../styles/theme';

export default function Navigation({ sections, project }) {
  const isScrolled = useScrolled(100);
  const sectionIds = sections.filter(s => s.enabled).map(s => s.id);
  const activeSection = useScrollSpy(sectionIds, 150);

  return (
    <motion.nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      style={{
        backgroundColor: isScrolled ? 'rgba(0, 0, 0, 0.95)' : 'transparent',
        backdropFilter: isScrolled ? 'blur(10px)' : 'none',
        borderBottom: isScrolled ? '1px solid #333333' : 'none',
        boxShadow: isScrolled ? theme.shadows.md : 'none',
      }}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 hover:opacity-80 transition"
          >
            <img src="/logo.svg" alt="Logo" className="h-10 w-10" />
            <span className="font-bold text-xl hidden sm:inline">Patrick Sanchez</span>
          </button>

          {/* Menu navigation - Desktop */}
          <ul className="hidden lg:flex items-center gap-1">
            {sections.filter(s => s.enabled).map((section) => {
              const Icon = Icons[section.icon];
              const isActive = activeSection === section.id;

              return (
                <li key={section.id}>
                  <button
                    onClick={() => scrollToSection(section.id)}
                    className={`
                      flex items-center gap-2 px-4 py-2 rounded-lg
                      transition-all duration-200
                      ${isActive
                        ? 'bg-primary-500 text-white font-semibold'
                        : 'text-secondary-200 hover:bg-secondary-800 hover:text-white'
                      }
                    `}
                  >
                    <Icon size={18} />
                    <span>{section.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>

          {/* Menu mobile */}
          <button className="lg:hidden p-2 hover:bg-secondary-800 rounded-lg transition text-white">
            <Icons.Menu size={24} />
          </button>
        </div>
      </div>
    </motion.nav>
  );
}
